import LegalPageLayout from '../components/LegalPageLayout';

const sections = [
  { id: 'article-1', title: 'Article 1 - Objet et Champ d\'Application' },
  { id: 'article-2', title: 'Article 2 - Accès à la Plateforme' },
  { id: 'article-3', title: 'Article 3 - Droits et Obligations' },
  { id: 'article-4', title: 'Article 4 - Géolocalisation' },
  { id: 'article-5', title: 'Article 5 - Contenu Utilisateurs' },
  { id: 'article-6', title: 'Article 6 - Notifications Push' },
  { id: 'article-7', title: 'Article 7 - Propriété Intellectuelle' },
  { id: 'article-8', title: 'Article 8 - Responsabilité' },
  { id: 'article-9', title: 'Article 9 - Liens Tiers' },
  { id: 'article-10', title: 'Article 10 - Conformité' },
  { id: 'article-11', title: 'Article 11 - Service Client' },
  { id: 'article-12', title: 'Article 12 - Suspension/Résiliation' },
  { id: 'article-13', title: 'Article 13 - Modification des CGU' },
  { id: 'article-14', title: 'Article 14 - Force Majeure' },
  { id: 'article-15', title: 'Article 15 - Droit Applicable' },
];

export default function CGU() {
  return (
    <LegalPageLayout
      title="Conditions Générales d'Utilisation (CGU)"
      subtitle="LEMO - Plateforme de commande de restauration en click & collect"
      lastUpdate="26 décembre 2025"
      sections={sections}
    >
      <section id="article-1">
        <h2>Article 1 - Objet et Champ d'Application</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation 
          de l'application mobile LEMO et du site web LEMO par les utilisateurs.
        </p>
        <p>
          En téléchargeant, accédant ou en utilisant l'application ou le site web, vous acceptez 
          sans réserve les présentes CGU ainsi que la Politique de Confidentialité.
        </p>
      </section>

      <section id="article-2">
        <h2>Article 2 - Accès à la Plateforme</h2>
        
        <h3>2.1 - Inscription et Compte Utilisateur</h3>
        <ul>
          <li>L'création d'un compte est obligatoire pour accéder aux services LEMO</li>
          <li>Vous êtes responsable des informations fournies lors de l'inscription</li>
          <li>Vous vous engagez à ne pas créer plusieurs comptes ou à usurper l'identité d'une autre personne</li>
          <li>Les informations fournies (nom, email, téléphone) doivent être exactes et à jour</li>
        </ul>

        <h3>2.2 - Identifiants et Sécurité</h3>
        <ul>
          <li>Vous êtes responsable de la confidentialité de votre mot de passe et de vos identifiants</li>
          <li>Vous êtes responsable de toute activité effectuée sous votre compte</li>
          <li>Vous vous engagez à notifier immédiatement LEMO en cas d'utilisation non autorisée</li>
        </ul>

        <h3>2.3 - Accès à la Plateforme</h3>
        <ul>
          <li>LEMO s'efforce de rendre la plateforme accessible 24h/24, 7j/7</li>
          <li>LEMO ne garantit pas l'accès ininterrompu en cas de maintenance ou de force majeure</li>
          <li>LEMO se réserve le droit de restreindre ou suspendre l'accès à tout moment</li>
        </ul>
      </section>

      <section id="article-3">
        <h2>Article 3 - Droits et Obligations de l'Utilisateur</h2>
        
        <h3>3.1 - Droits</h3>
        <p>L'utilisateur a le droit de :</p>
        <ul>
          <li>Accéder à la plateforme LEMO dans le respect de la loi</li>
          <li>Consulter les menus et tarifs des restaurants partenaires</li>
          <li>Passer des commandes et effectuer des paiements</li>
          <li>Bénéficier du service client</li>
        </ul>

        <h3>3.2 - Obligations</h3>
        <p>L'utilisateur s'engage à :</p>
        <ul>
          <li>Utiliser la plateforme de manière légale et conforme à la loi</li>
          <li>Ne pas générer de contenu illégal, diffamatoire ou haineux</li>
          <li>Respecter les droits de propriété intellectuelle de LEMO et de ses partenaires</li>
          <li>Ne pas publier d'informations personnelles d'autres utilisateurs</li>
          <li>Ne pas tenter de pirater ou d'interférer avec la sécurité de la plateforme</li>
          <li>Ne pas utiliser la plateforme à des fins commerciales ou publicitaires sans autorisation</li>
        </ul>
      </section>

      <section id="article-4">
        <h2>Article 4 - Utilisation des Données Géolocalisation (Google Maps)</h2>
        
        <h3>4.1 - Localisation GPS</h3>
        <p>LEMO utilise Google Maps pour :</p>
        <ul>
          <li>Afficher votre localisation actuelle</li>
          <li>Proposer les restaurants disponibles à proximité</li>
          <li>Vous fournir les itinéraires pour le retrait</li>
        </ul>

        <h3>4.2 - Consentement</h3>
        <p>
          L'utilisation de la géolocalisation requiert votre consentement explicite. 
          Vous devez autoriser LEMO à accéder à votre localisation GPS lors de la première utilisation.
        </p>

        <h3>4.3 - Conditions d'utilisation de Google Maps</h3>
        <p>
          L'utilisation de Google Maps est soumise aux conditions d'utilisation de Google. 
          Pour plus d'informations, consultez la politique de confidentialité de Google.
        </p>
      </section>

      <section id="article-5">
        <h2>Article 5 - Contenu Généré par les Utilisateurs</h2>
        
        <h3>5.1 - Commentaires et Avis</h3>
        <p>LEMO permet aux utilisateurs de laisser des commentaires, des avis et des notes sur les restaurants.</p>

        <h3>5.2 - Responsabilité de l'utilisateur</h3>
        <p>En publiant un contenu (avis, commentaire, photo), vous confirmez que :</p>
        <ul>
          <li>Vous êtes l'auteur de ce contenu</li>
          <li>Ce contenu ne viole pas les droits de tiers</li>
          <li>Ce contenu n'est pas diffamatoire, haineux, illégal ou contraire aux bonnes mœurs</li>
          <li>Vous possédez les droits d'auteur sur tout contenu publié</li>
        </ul>

        <h3>5.3 - Modération</h3>
        <ul>
          <li>LEMO se réserve le droit de modérer, d'éditer ou de supprimer tout contenu</li>
          <li>Les contenus non conformes aux présentes CGU seront supprimés sans préavis</li>
          <li>Les restaurateurs partenaires peuvent répondre aux avis et commentaires</li>
          <li>La modération est effectuée par un service dédié</li>
        </ul>

        <h3>5.4 - Licence d'utilisation</h3>
        <p>
          En publiant du contenu, vous accordez à LEMO une licence non-exclusive, gratuite et perpétuelle 
          pour utiliser, reproduire, modifier et afficher ce contenu sur la plateforme.
        </p>

        <h3>5.5 - Photos Uploadées</h3>
        <ul>
          <li>Les utilisateurs peuvent uploader des photos de leurs commandes</li>
          <li>Les photos uploadées doivent respecter les lois sur le droit à l'image</li>
          <li>LEMO se réserve le droit d'utiliser les photos à des fins promotionnelles (sauf opposition expresse)</li>
          <li>Vous êtes responsable de ne pas uploader de contenu illégitime ou contraire à la loi</li>
        </ul>
      </section>

      <section id="article-6">
        <h2>Article 6 - Notifications Push</h2>
        
        <h3>6.1 - Consentement</h3>
        <p>
          L'utilisation des notifications push requiert votre consentement explicite 
          lors du premier lancement de l'application.
        </p>

        <h3>6.2 - Contenus des notifications</h3>
        <p>Les notifications push contiennent :</p>
        <ul>
          <li>Confirmations de commande</li>
          <li>Mises à jour du statut de préparation</li>
          <li>Offres promotionnelles et informations commerciales</li>
          <li>Alertes de service</li>
        </ul>

        <h3>6.3 - Gestion des notifications</h3>
        <p>
          Vous pouvez désactiver les notifications à tout moment dans les paramètres 
          de votre téléphone ou de l'application.
        </p>
      </section>

      <section id="article-7">
        <h2>Article 7 - Propriété Intellectuelle</h2>
        
        <h3>7.1 - Contenu LEMO</h3>
        <p>
          Tous les contenus présents sur la plateforme (textes, images, logos, graphiques, vidéos, 
          interfaces utilisateur, etc.) sont la propriété exclusive de LEMO ou de ses partenaires 
          et sont protégés par les droits d'auteur.
        </p>

        <h3>7.2 - Restrictions</h3>
        <p>Vous vous engagez à ne pas :</p>
        <ul>
          <li>Reproduire, copier ou modifier les contenus</li>
          <li>Utiliser les contenus à des fins commerciales</li>
          <li>Télécharger ou récupérer les contenus de manière non autorisée</li>
          <li>Contourner les mesures de protection</li>
        </ul>

        <h3>7.3 - Utilisation limitée</h3>
        <p>
          Vous êtes autorisé à utiliser les contenus uniquement pour votre usage personnel 
          et non-commercial, dans le respect de la loi.
        </p>
      </section>

      <section id="article-8">
        <h2>Article 8 - Responsabilité de LEMO</h2>
        
        <h3>8.1 - Limitation de responsabilité</h3>
        <p>LEMO agit en tant que plateforme de mise en relation. LEMO ne peut être tenue responsable de :</p>
        <ul>
          <li>La qualité, la conformité ou la sécurité des produits proposés par les restaurateurs (responsabilité du restaurateur)</li>
          <li>Les délais de préparation ou de livraison</li>
          <li>Les dommages subis après retrait de la commande</li>
          <li>Les indisponibilités ou dysfonctionnements techniques non imputables à LEMO</li>
          <li>Les pertes ou dégâts non causés directement par une faute prouvée de LEMO</li>
        </ul>

        <h3>8.2 - Exclusion de garantie</h3>
        <p>
          La plateforme est fournie "EN L'ÉTAT" sans garantie expresse ou implicite, 
          sauf ce qui est expressément stipulé dans les présentes CGU.
        </p>

        <h3>8.3 - Limitation de dommages</h3>
        <p>
          En aucun cas, LEMO ne sera responsable de dommages indirects, accidentels, spéciaux 
          ou consécutifs liés à l'utilisation ou à l'impossibilité d'utiliser la plateforme.
        </p>
      </section>

      <section id="article-9">
        <h2>Article 9 - Liens Tiers et Contenu Externe</h2>
        <p>LEMO peut contenir des liens vers des sites web tiers (restaurateurs partenaires, Google Maps, etc.).</p>
        <ul>
          <li>LEMO n'est pas responsable du contenu de ces sites externes</li>
          <li>L'accès à ces sites est soumis à leurs propres conditions d'utilisation</li>
          <li>LEMO recommande de vérifier la légitimité des sites avant de partager des données</li>
        </ul>
      </section>

      <section id="article-10">
        <h2>Article 10 - Conformité et Conditions d'Utilisation Supplémentaires</h2>
        
        <h3>10.1 - Intégrations Tiers</h3>
        <p>L'utilisation de la plateforme implique le respect des conditions d'utilisation des services intégrés :</p>
        <ul>
          <li><strong>Stripe</strong> : traitement des paiements</li>
          <li><strong>Google Maps</strong> : services de localisation</li>
          <li><strong>Resend</strong> : envoi d'emails</li>
        </ul>

        <h3>10.2 - Cookies et Traceurs</h3>
        <ul>
          <li>LEMO n'utilise pas de cookies à titre obligatoire pour le fonctionnement de la plateforme</li>
          <li>Les données d'utilisation peuvent être collectées via Emergent.sh pour l'amélioration du service</li>
          <li>Un consentement explicite sera demandé pour les traceurs non essentiels</li>
        </ul>
      </section>

      <section id="article-11">
        <h2>Article 11 - Service Client et Réclamations</h2>
        
        <h3>11.1 - Contactez-nous</h3>
        <p>Pour toute question ou réclamation :</p>
        <ul>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
          <li><strong>Formulaire dans l'app</strong> : Menu "Aide" → "Contacter le support"</li>
        </ul>

        <h3>11.2 - Gestion des réclamations</h3>
        <ul>
          <li>Les réclamations doivent être signalées dans les <strong>24 heures</strong> suivant le retrait de la commande</li>
          <li>LEMO gère le litige avec le restaurateur impliqué</li>
          <li>Une réponse sera fournie dans un délai de <strong>10 jours ouvrables</strong> maximum</li>
          <li>Les clients insatisfaits peuvent demander un remboursement ou une compensation selon la nature du problème</li>
        </ul>
      </section>

      <section id="article-12">
        <h2>Article 12 - Suspension ou Résiliation de l'Accès</h2>
        
        <h3>12.1 - Cas de suspension ou résiliation</h3>
        <p>LEMO se réserve le droit de suspendre ou de résilier votre accès en cas de :</p>
        <ul>
          <li>Violation des présentes CGU</li>
          <li>Comportement frauduleux ou malhonnête</li>
          <li>Violation de la loi</li>
          <li>Abus du service ou spam</li>
          <li>Non-paiement</li>
        </ul>

        <h3>12.2 - Conséquences</h3>
        <ul>
          <li>Perte d'accès immédiate à la plateforme</li>
          <li>Conservation des données selon la Politique de Confidentialité</li>
          <li>Aucun remboursement pour les services déjà payés</li>
        </ul>

        <h3>12.3 - Droit de connaître les raisons</h3>
        <p>En cas de suspension, LEMO s'engage à vous informer des motifs de la suspension dans les meilleurs délais.</p>
      </section>

      <section id="article-13">
        <h2>Article 13 - Modification des CGU</h2>
        <p>LEMO se réserve le droit de modifier les présentes CGU à tout moment. Les modifications seront notifiées par :</p>
        <ul>
          <li>Une notification dans l'application</li>
          <li>Un email adressé à votre compte</li>
          <li>Une publication sur le site web</li>
        </ul>
        <p>
          Les modifications entrent en vigueur à leur publication. Si vous n'acceptez pas les modifications, 
          vous pouvez cesser l'utilisation de la plateforme.
        </p>
      </section>

      <section id="article-14">
        <h2>Article 14 - Force Majeure</h2>
        <p>LEMO ne sera pas responsable des défaillances liées à :</p>
        <ul>
          <li>Événements naturels (tremblements de terre, tempêtes, etc.)</li>
          <li>Pannes d'Internet généralisées</li>
          <li>Cyberattaques ou actes de piratage majeurs</li>
          <li>Crises sanitaires ou autres situations exceptionnelles</li>
        </ul>
      </section>

      <section id="article-15">
        <h2>Article 15 - Droit Applicable et Juridiction</h2>
        <ul>
          <li>Les présentes CGU sont régies par la loi française</li>
          <li>Tout litige relève de la compétence des tribunaux français, spécifiquement le tribunal de Nanterre (92)</li>
          <li>Les litiges seront en priorité gérés par voie amiable</li>
        </ul>
      </section>
    </LegalPageLayout>
  );
}
